import { render } from "./VCheckButton.vue?vue&type=template&id=55635f85"
import script from "./VCheckButton.vue?vue&type=script&lang=js"
export * from "./VCheckButton.vue?vue&type=script&lang=js"

import "./VCheckButton.vue?vue&type=style&index=0&id=55635f85&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__